<template>

    <div class="text-xs-left">
      <v-btn round class="secondary" :to="{name: 'Dashboard'}">
        <v-icon left dark>{{$vuetify.icons.back}}</v-icon>
        Return to Dashboard
      </v-btn>
    </div>

</template>

<script>

export default {
  name: 'ReturnToDashboard',
  components: {
  },
  data () {
    return {
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
